$(document).ready(function(){
  $('.qz_primary_btn').click(function(evt){
    evt.preventDefault();
    console.log('Primary button');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".product_section_holder").offset().top
    }, 500);
  });

  $('.em_hero_btn').click(function(evt){
    evt.preventDefault();
    console.log('Primary button');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".product_section_holder").offset().top
    }, 500);
  });

  $('.btn_container a').click(function(evt){
    evt.preventDefault();
    console.log('Primary button');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".product_section_holder").offset().top
    }, 500);
  });

  $('.qz_primary_btn.slideToSummary').click(function(evt){
    evt.preventDefault();
    console.log('Primary button');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".product_section_holder").offset().top
    }, 500);
  });
});